// Validación en vivo del formato de lote en A1 (B7). Misma regla que aplica
// el API (`validarFormatoLoteConfig`), desglosada por campo para la UI.

import { FORMATO_LOTE_REGEX_MAX_LEN, compilarFormatoLote, validarLote } from 'schemas';

export interface EvaluacionFormatoLote {
  /** Error de la expresión (vacía, muy larga o no compila); null si compila. */
  errorRegex: string | null;
  /** Error del ejemplo (vacío o no cumple); null si cumple. */
  errorEjemplo: string | null;
  /** Primer error para mostrar o bloquear el guardado; null si todo cuadra. */
  error: string | null;
}

export function evaluarFormatoLote(regex: string, ejemplo: string): EvaluacionFormatoLote {
  const r = regex.trim();
  const ej = ejemplo.trim();
  let errorRegex: string | null = null;
  if (r === '') errorRegex = 'La expresión es obligatoria.';
  else if (r.length > FORMATO_LOTE_REGEX_MAX_LEN)
    errorRegex = `La expresión admite máximo ${FORMATO_LOTE_REGEX_MAX_LEN} caracteres.`;
  else if (compilarFormatoLote(r) === null) errorRegex = 'La expresión no es válida.';

  let errorEjemplo: string | null = null;
  if (ej === '') errorEjemplo = 'Indique un ejemplo de lote válido.';
  else if (errorRegex === null && !validarLote(ej, r))
    errorEjemplo = 'El ejemplo no cumple la expresión.';

  return { errorRegex, errorEjemplo, error: errorRegex ?? errorEjemplo };
}
